export enum Resources {
  ClubProfile = 'club-profile',
  Users = 'users',
  Profiles = 'profiles',
  GroupInvites = 'groupInvites',
  Groups = 'groups',
  Customers = 'customers',
  Subscriptions = 'subscriptions',
  Products = 'products',
  Prices = 'prices',
  ApiKeys = 'apiKeys',
  Billing = 'billing',
  Academy = 'academy',
  Clubs = 'clubs',
  Notifications = 'notifications',
}
